/**
 * useRecentTemplateTouch.ts
 *
 * Hook exposing a fire-and-forget "touch" for a template, recorded to the
 * per-user recent-templates list (search-service) whenever a builder opens
 * or saves it. Mirrors `recent-spheres` touch semantics: failures never
 * surface to the caller.
 */

import { useCallback } from 'react';
import type { ApiClients } from '../context/ApiClientsContext';
import { touchRecentTemplate } from '../api/studioApi';

export type TouchRecentTemplate = (templateId: string) => void;

/**
 * @param apiClients - API clients (pass null if not ready; touch becomes a no-op)
 */
export function useRecentTemplateTouch(apiClients: ApiClients | null): TouchRecentTemplate {
  return useCallback(
    (templateId: string) => {
      if (!apiClients?.searchClient || !templateId) return;
      touchRecentTemplate(apiClients.searchClient, templateId).catch(() => {
        // Fire-and-forget: recent-templates is a convenience list, never load-bearing.
      });
    },
    [apiClients]
  );
}
